module.exports = __webpack_public_path__ + "img/position_CF.c3f0b3da.png";